import { SET_HEADER_INFO } from "../mutation-types";
import { infoHeader } from "@/services/header";

export default {
  [SET_HEADER_INFO]: async state => {
    const [error, data] = await infoHeader();
    if (error) {
      state.errorMessagesHeader = error;
    } else {
      if (data.apiStatus === 200) {
        state.balance = data.apiData.balance;
        state.title = data.apiData.title;
        state.numOfUnReadMessage = data.apiData.numOfUnReadMessage;
      } else {
        state.errorMessagesHeader = data.apiErrors;
      }
    }
  }
};
